
<div class="pages" #pagesElement>
  <ng-content></ng-content>
</div>
<button type="button" [class.hidden]="!hasPages" class="page-button previous-page-button" kb-icon [icon]="iconArrowLeft" icon-uppercase icon-center [attr.aria-label]="intl.previousPageButtonLabel" (click)="openPreviousPage()"></button>
<button type="button" [class.hidden]="!hasPages" class="page-button next-page-button" kb-icon [icon]="iconArrowRight" icon-uppercase icon-center [attr.aria-label]="intl.nextPageButtonLabel" (click)="openNextPage()"></button>
